@if (canAccessBuilder) {
  <ng-container
    *ngTemplateOutlet="
      groupContainer;
      context: {
        $implicit: {
          title: 'Report Builder',
          reports: reportBuilderReports(),
          isLoading: isLoading().reportBuilder,
          icon: 'ts_graph-bar',
          url: '/reporting/list',
          queryParams: { type: 'builder' },
        },
      }
    "
  ></ng-container>
}
@if (canAccessPdf) {
  <ng-container
    *ngTemplateOutlet="
      groupContainer;
      context: {
        $implicit: {
          title: 'PDF Reports',
          reports: pdfReports(),
          isLoading: isLoading().pdfReports,
          icon: 'ts_file-info-alt',
          url: '/reporting/list',
          queryParams: { type: 'pdf' },
        },
      }
    "
  ></ng-container>
}

<ng-container
  *ngTemplateOutlet="
    groupContainer;
    context: {
      $implicit: {
        title: 'Dashboards',
        reports: dashboards(),
        isLoading: isLoading().dashboards,
        icon: 'ts_create-dashboard',
        url: '/dashboard',
        queryParams: null,
      },
    }
  "
></ng-container>
<ng-template #groupContainer let-data>
  <div class="group">
    <div class="header">
      <ts-icon [icon]="data.icon" size="small" class="info-icon"></ts-icon> <span>{{ data.title }}</span>
      <ts-icon
        icon="open_in_new"
        size="small"
        class="navigate-icon"
        [routerLink]="data.url"
        [queryParams]="data.queryParams"
        (click)="onNavigate.emit()"
      ></ts-icon>
    </div>
    <ts-divider spacing="none"></ts-divider>
    <ts-tree-menu
      sidenav
      [suppressHeader]="true"
      [items]="data.reports ?? []"
      [loading]="data.isLoading"
      [delegateLeafClickFn]="delegateLeafClickFn.bind(this)"
      [smallSkeleton]="true"
    ></ts-tree-menu>
  </div>
</ng-template>
